import { MatPaginatorIntl } from '@angular/material/paginator';


const ItaRangeLabel = (page: number, pageSize: number, length: number) => {
  if (length == 0 || pageSize == 0) { return `0 di pagina ${page + 1}`; }
  
  length = Math.max(length, 0);

  const startIndex = page * pageSize;

  // If the start index exceeds the list length, do not try and fix the end index to the end.
  const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;

  return `${startIndex + 1} - ${endIndex} di pagina ${page + 1}`;
}


export function getItaPaginatorIntl() {
  const paginatorIntl = new MatPaginatorIntl();
  
  paginatorIntl.itemsPerPageLabel = 'Elementi per pagina:';
  paginatorIntl.nextPageLabel = 'Prossima pagina';
  paginatorIntl.previousPageLabel = 'Precedente pagina';
  paginatorIntl.getRangeLabel = ItaRangeLabel;
  
  return paginatorIntl;
}